import PropTypes from 'prop-types'
import { FONT_SIZES, FONT_WEIGHTS, LINE_HEIGHT, COLORS } from '../../theme'
import themes from '../../theme/themes'
const themeNames = Object.keys(themes)

const defaultArgsTypes = {
  disabled: {
    control: 'boolean',
  },
  size: {
    control: 'select',
    options: FONT_SIZES,
  },
  fontSize: {
    control: 'select',
    options: FONT_SIZES,
  },
  fontWeight: {
    control: 'select',
    options: FONT_WEIGHTS,
  },
  textAlign: {
    control: 'select',
    options: ['right', 'left', 'center'],
  },
  align: {
    control: 'select',
    options: ['bottom', 'middle', 'top'],
  },
  lineHeight: {
    control: 'select',
    options: LINE_HEIGHT,
  },
  fontColor: {
    control: 'select',
    options: COLORS,
  },
  color: {
    control: 'select',
    options: COLORS,
  },
  errorColor: {
    control: 'select',
    options: COLORS,
  },
  rightIcon: {
    control: 'text',
  },
  label: {
    control: 'text',
  },
  padding: {
    control: 'text',
  }
}

const defaultArgs = {
  label: 'Label',
  name: 'Myname',
  id: 'ID',
  'data-test': 'data-test',
  dataTest: 'data-test',
}

const getArgsTypes = (Element, ignore = []) => {
  const propTypes = Element.propTypes || {}
  const args = {
    THEME: {
      control: 'select',
      options: themeNames,
    },
    LOCALE: { control: 'select', options: ['es'] }
  }
  Object.keys(propTypes)
    .filter((prop) => !ignore.includes(prop))
    .forEach((prop) => {
      if (defaultArgsTypes[prop]) {
        args[prop] = defaultArgsTypes[prop]
      }
    })
  return args
}

const getArgs = (Element, ignore = []) => {
  const props = Element.propTypes || {}
  const defaultProps = Element.defaultProps || {}
  const args = {
    THEME: themeNames[0],
  }
  Object.keys(props)
    .filter((prop) => !ignore.includes(prop))
    .forEach((prop) => {
      if (!(props[prop] === PropTypes.func)) {
        if (defaultProps[prop]) {
          args[prop] = defaultProps[prop]
        }
        if (defaultArgs[prop]) {
          args[prop] = defaultArgs[prop]
        }
      }
    })
  return args
}

export { getArgs, getArgsTypes }
